import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  lifecycle,
  withHandlers,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {
  FormControlLabel,
  List,
  ListItem,
  Modal,
  Radio,
  RadioGroup
} from '@material-ui/core';
import classNames from 'classnames';
import {
  getMenuImageSample,
  GET_MENU_IMAGE_SUCCESS
} from '../../actions/GochiMenus';
import { getOptionShops } from '../../actions/Options';
import { sendLogin } from '../../auth/Auth';
import RequiredButton from '../../components/atoms/RequiredButton';
import usageTypes from '../../constants/UsageType';
import CancelButton from '../../components/atoms/CancelButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import GochiMenuAddShopV2 from './GochiMenuAddShopV2';
import SubmitButton from '../../components/atoms/SubmitButton';

const styles = () => ({
  root: {
    // position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    padding: 0,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4
  },
  pageTitle: {
    margin: '48px 0px 0px',
    paddingLeft: 20,
    textAlign: 'left',
    color: '#000000',
    fontSize: 24,
    fontWeight: 700
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: 0,
    boxShadow: 'none'
  },
  listForm: {
    display: 'block',
    paddingBottom: 0,
    paddingTop: 14
  },
  itemForm: {
    display: 'block',
    padding: '16px 20px 8px'
  },
  btnBtom: {
    padding: '22px 20px 40px 20px'
  },
  labelControl: {
    marginTop: 16
  },
  labelText: {
    color: '#757575',
    fontSize: 14
  },
  noteText: {
    color: '#000000',
    fontSize: 14,
    fontWeight: 400,
    marginBottom: 8
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      shops: state.shops.shops,
      // shops: state.options.listShops,
      groups: state.options.listGroups,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getOptionShops,
          getMenuImageSample
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'setLoading', false),
  withState('message', 'setMessage', ''),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('groups', 'setGroups', []),
  withState('shops', 'setShops', []),
  withState('usageType', 'setUsageType', usageTypes[0].id),
  withState('shopGochiRestriction', 'setShopGochiRestriction', ''),
  withState('menuImageSampleList', 'setMenuImageSampleList', []),
  withState('shopName', 'setShopName', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionShops().then(data => {
        this.props.checkSession(data);
        this.props.setShops(data.payload.list);
        if (data.payload.list && data.payload.list.length > 0) {
          const shopTemp = data.payload.list.find(
            shop => shop.shopId === this.props.shopId
          );
          if (shopTemp) {
            this.props.setShopName(shopTemp.shopName);
            this.props.setShopGochiRestriction(shopTemp.gochiRestriction);
          }
        }
      });
    }
  })
);

const Main = enhance(
  ({
    actions,
    openAdd,
    updateOpenAdd,
    message,
    setMessage,
    openProgress,
    updateOpenProgress,
    loading,
    setLoading,
    classes,
    updateOpenAddChooseUsageType,
    usageType,
    setUsageType,
    errorMessage,
    setErrorMessage,
    shopId,
    searchKey,
    handleChangePage,
    menuGenre,
    shopGochiRestriction,
    menuImageSampleList,
    setMenuImageSampleList,
    shopName
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0];
    const USAGE_TYPE_VOUCHER = usageTypes[1];
    const USAGE_TYPE_COMBO = usageTypes[2];

    const process = {
      message,
      setMessage,
      openProgress,
      updateOpenProgress,
      loading,
      setLoading,
      errorMessage,
      setErrorMessage
    };

    const handleCloseChosseUsageType = () => {
      updateOpenAddChooseUsageType(false);
    };

    const handleOpenAddMenu = async () => {
      updateOpenProgress(true);
      setLoading(true);
      if (usageType === USAGE_TYPE_MENU.id) {
        const response = await actions.getMenuImageSample();
        if (response.type === GET_MENU_IMAGE_SUCCESS) {
          setMenuImageSampleList(response.payload);
        } else {
          setMenuImageSampleList([]);
        }
      } else {
        setMenuImageSampleList([]);
      }
      updateOpenAdd(true);
      updateOpenProgress(false);
      setLoading(false);
    };

    const progressOkAction = () => {
      handleChangePage(null, 1, 10);
      updateOpenProgress(false);
      setMessage('');
      updateOpenAddChooseUsageType(false);
    };

    return (
      <>
        <div className={classes.root}>
          <div>
            <Typography className={classes.pageTitle}>
              メニュー追加（1/2）
            </Typography>
          </div>
          <Paper className={classes.mainPaper} elevation={1}>
            <List component="nav" className={classes.listForm}>
              <ListItem className={classes.itemForm}>
                <Typography component="div">
                  <RequiredButton />
                </Typography>
                <Typography
                  component="div"
                  className={classNames(
                    classes.labelText,
                    classes.labelControl
                  )}
                >
                  用途
                </Typography>
                <Typography component="div" className={classes.formInput}>
                  <RadioGroup
                    value={usageType}
                    onChange={e => {
                      setUsageType(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      value={USAGE_TYPE_MENU.id}
                      control={<Radio color="primary" />}
                      label={USAGE_TYPE_MENU.name}
                    />
                    <div className={classes.noteText}>
                      メニュー毎に販売（例：日替りランチ、○○弁当など）
                    </div>
                    <FormControlLabel
                      value={USAGE_TYPE_VOUCHER.id}
                      control={<Radio color="primary" />}
                      label={USAGE_TYPE_VOUCHER.name}
                    />
                    <div className={classes.noteText}>
                      金額を決めて販売（例：500円券、1,000円券など）
                    </div>
                    <FormControlLabel
                      value={USAGE_TYPE_COMBO.id}
                      control={<Radio color="primary" />}
                      label={USAGE_TYPE_COMBO.name}
                    />
                    <div className={classes.noteText}>
                      複数枚をセットで販売（例：５回分の価格で６回使える、など）
                    </div>
                  </RadioGroup>
                </Typography>
              </ListItem>
            </List>
          </Paper>
          <div className={classes.btnBtom}>
            <CancelButton
              onClickAction={handleCloseChosseUsageType}
              color="primary"
            />
            <SubmitButton onClickAction={handleOpenAddMenu} btnText="次へ" />
          </div>
        </div>

        <Modal open={openAdd} className={classes.modalMobile}>
          <GochiMenuAddShopV2
            updateOpenAdd={updateOpenAdd}
            searchKey={searchKey}
            shopId={shopId}
            handleChangePage={handleChangePage}
            menuGenre={menuGenre}
            processBox={process}
            usageType={usageType}
            shopGochiRestriction={shopGochiRestriction}
            menuImageSampleList={menuImageSampleList}
            shopName={shopName}
          />
        </Modal>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={message}
        />

        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
